
<h1>Log In</h1>

<form (submit)="submit($event)">
    <mat-form-field>
        <input matInput
               [formField]="loginForm.email"
               placeholder="Email">
        <mat-error>
            <app-field-errors [formField]="loginForm.email"></app-field-errors>
        </mat-error>
    </mat-form-field>

    <aa-password-input label="Password"
                       [formField]="loginForm.password"
                       placeholder="Password"></aa-password-input>

    @if (!isTrustedDevice()) {
        <div>
            <mat-form-field>
                <mat-label>2FA code</mat-label>
                <input matInput
                       [formField]="loginForm.code"
                       placeholder="6-digit code">
                <mat-error>
                    <app-field-errors [formField]="loginForm.code"></app-field-errors>
                </mat-error>
            </mat-form-field>

            <mat-checkbox [formField]="loginForm.trustThisDevice">Trust this device</mat-checkbox>
        </div>
    }
    <div class="button_row">
        <button mat-raised-button
                color="primary"
                [disabled]="!canSubmit()"
                type="submit">Log In</button>
    </div>

    <div class="link" routerLink="/forgot-password">Forgot password?</div>

</form>
